<template>
  <div class="popBind">
    <select id="server" class="abs server" ref="server"></select>
    <button class="abs confirmBind" @click="confirmBind"></button>
  </div>
</template>

<script>
import { saveRole } from '@/network/api'
import { closePop, updateInitUser } from '@/utils/common'

export default {
  mounted(){
    var sr = $.serverRole({
      url: process.env.VUE_APP_API_URL + '/mobile/roleList/getRoleList',
      data : {
        event : 'ht', //ht, test_example
        type: true
      },
      serverNode : $('#server'),
    });
  },
  methods: {
    closePop,
    updateInitUser,
    confirmBind(){
      const server = this.$refs.server;
      const selectedIndex = server.selectedIndex;
      const roleId = server.options[selectedIndex].getAttribute('roleid');
      const params = {
        roleId
      }
      if(!params.roleId){
        alert('请选择角色');
        return;
      }
      saveRole(params).then(res => {
        if(res.status === 1){
          this.updateInitUser();
          this.closePop();
        }
        alert(res.message)
      })
    }
  }
}
</script>

<style scoped>
.popBind{ width: 681px; height: 670px; background: url(@images/popBind.png) no-repeat 0 0;}
.server{ top: 376px; left: 161px; box-sizing: border-box; padding: 0 90px 0 10px; width: 371px; height: 82px; text-align: center; font-size: 44px; background: #7f3cd8 url(@images/icon_select.png) no-repeat 290px center; border-radius: 41px; color: #FFF;}
.confirmBind{ top: 481px; left: 161px; width: 371px; height: 83px; background: url(@images/confirmBind.png) no-repeat 0 0;}
</style>